import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CookieIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
    <circle cx="8.5" cy="8.5" r="1" fill="currentColor" />
    <circle cx="12" cy="14" r="1" fill="currentColor" />
    <circle cx="16" cy="10" r="1" fill="currentColor" />
  </svg>
);

function CookieBanner({ open, onAcceptAll, onRejectAll }) {
  const dialogRef = useRef(null);

  return (
    <div
      ref={dialogRef}
      className={`cookie-banner ${open ? 'is-open' : ''}`}
      role="dialog"
      aria-label="Consenso cookie"
      aria-modal="true"
      aria-hidden={!open}
    >
      <div className="cookie-banner__card">
        <div className="cookie-banner__header">
          <div className="cookie-banner__title-row">
            <CookieIcon className="cookie-banner__icon" />
            <h2 className="cookie-banner__title">Questo sito utilizza i cookie</h2>
          </div>
          <p className="cookie-banner__desc">
            Utilizziamo cookie tecnici per il funzionamento del sito e Google Fonts
            (servizio di Google Ireland) per la grafica. Rifiutando vedrai il sito con
            font di sistema. Per dettagli consulta la nostra{' '}
            <Link to="/cookie-policy" target="_blank" rel="noopener noreferrer">
              cookie policy
            </Link>{' '}
            e la{' '}
            <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
              privacy policy
            </Link>
            .
          </p>
        </div>

        <div className="cookie-banner__prefs">
          <div className="cookie-banner__pref">
            <div className="cookie-banner__pref-text">
              <p className="cookie-banner__pref-label">Necessari</p>
              <p className="cookie-banner__pref-desc">Funzionamento base del sito</p>
            </div>
            <span className="cookie-banner__pill">Sempre attivi</span>
          </div>
        </div>

        <div className="cookie-banner__actions">
          <div className="cookie-banner__buttons-row">
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--reject"
              onClick={onRejectAll}
            >
              Rifiuta
            </button>
            <button
              type="button"
              className="cookie-banner__btn cookie-banner__btn--accept"
              onClick={onAcceptAll}
            >
              Accetta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
